// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"884":"admin","966":"login"}[chunkId] + "." + {"884":"3a0e3fa7","966":"c175554b"}[chunkId] + ".js";
};